define('commons/city-area-results',['jquery', 'commons/tap-coverage-map', 'commons/toggle-selector', 'commons/message-manager', 'jquery.ui', 'async!google-maps'], function($, BaseStationCoverageMap, ToggleSelector, messages) {

   return function(data, options) {
       
       this.settings = {
           minDb: 0,
           maxDb: 0,
           taskId: "",
           rpId: "",
           useTile: false,
           captionSelector: '#coverage-mode',
       };
       $.extend(this.settings, options);
       
        this.areaStats =  data.areaStats;
        this.info = new google.maps.InfoWindow({maxWidth: 150});

        this.CONSTANTS = (function() {
            var privateConstants = {
                'MIN_DISPLAYED_VALUES': 1,
                'MAX_DISPLAYED_VALUES': 3,
                'USER_PREFS_LIST_URL': '/userPrefs/json/fields/city-area/list',
                'USER_PREFS_EDIT_URL': '/userPrefs/edit/city-area'
            };

            return {
                get: function(name) {
                    return privateConstants[name];
                }
            };
        })();

        // global results
        var resultTextDensity = $(".density-global");
        var resultTextPopulation = $(".population-count-global");

        var nbSensi = (this.settings.maxDb - this.settings.minDb + 1);

        // [{sensi: 20, overlap: 2}, {sensi: ...]
        var valueColors = [ "blue" , "yellow", "green"];
        this.values = [{sensi: 0, overlap: 1}, {sensi: 22, overlap: 1}, {sensi: 12, overlap: 2}];
        var resultTextValue = [];
        for (var k = 0; k < this.values.length; k++) {
            resultTextValue[k] = $(".coverage" + k + "-global");
        }

        // update density and population
        // areaStats index are from -1 to -3
        var j = -1;
        for (var i = 0; i < 3; i++) {
            var areaStat = this.areaStats[j];
            var density = Number(areaStat.density);
            var population = Number(areaStat.population);
            $(resultTextDensity[i]).html(Math.round(density) + " Pop/Km&sup2;");
            $(resultTextPopulation[i]).html(Math.round(population) + " Hab");
            j--;
        }

        // Create the map
        this.coverageMap = new BaseStationCoverageMap("map", {
            minDb: this.settings.minDb,
            maxDb: this.settings.maxDb,
            captionOffset: {
                x: 15,
                y: -5
            },
            clusterer : {
                isDisabled : true,
            },
            canEditSimulation : false,
            displayDensity: true,
            displayLandCover: true,
            captionSelector: this.settings.captionSelector,
            binUrl: "/simulation/bin/" + this.settings.rpId,
            fullScreen: 'map-wrapper',
            useTile: this.settings.useTile,
            colorSteps: [ 0, 100, 500, 1500, 5000, 25000 ],
            targets: [],
            densityBaseImgUrl: "",
            landCoverBaseImgUrl: "",
        });

        this.loadCoverage = function() {
            $.ajax({
                type: "GET",
                url: "/cityArea/coverage/" + this.settings.rpId + "/" + this.settings.taskId,
                datatype: 'json',
                success : $.proxy(function(result) {
                    this.coverageMap.settings.useTile = result.useTile == true;
                    this.coverageMap.removeCoverages();
                    this.coverageMap.removeTiles();

                    if (result.useTile) {
                        if (result.conf) {
                            this.coverageMap.settings.colorSteps = result.conf.colorSteps;
                            this.coverageMap.settings.targets = result.conf.targets;
                            if (result.geodataBaseImgUrls) {
                                this.coverageMap.settings.densityBaseImgUrl = result.geodataBaseImgUrls[result.conf.currentPopulationSet];
                                this.coverageMap.settings.landCoverBaseImgUrl = result.geodataBaseImgUrls[result.conf.currentLandcoverSet];
                            }
                            this.coverageMap.loadTiles([result.baseImgUrl], 0);
                        }
                    } else {
                        this.coverageMap.loadCoverages(result.coverage);
                    }
                }, this)
            });
        };
        var colorBlue = '#86adf1';
        var colorPurple = '#830080';
        var colorOrange = '#ff8c00';

        var baseOptions = {
            map: this.coverageMap.map,
            fillColor: colorBlue,
            fillOpacity: 0.10,
            strokeColor: colorBlue,
            strokeWeight: 3
        };

        this.bounds = null;

        var resultsCircleInfo = function(index, stats, circle, name, isUrban) {
            var displayName = name ? name : (isUrban ? "Urban" : "Suburban") + " circle " + ((index / 2) + 1);
            var content = "<h3><i class='icon-circle-blank icon-large  " + (isUrban ? "urban" : "suburban") + "'></i> " + displayName + "</h3><br/>" +
                    "<table class='city-area-info'>" +
                    "<tr>" +
                    "<td class='center'><i class='icon-group icon-large'></i></td><td>" + Math.round(stats.density) + " Pop/km&sup2;</td>" +
                    "</tr><tr>" +
                    "<td class='center'><i class='icon-user icon-large'></i></td><td> " + Math.round(stats.population) + " hab</td>" +
                    "</tr><tr>" +
                    "<td class='center'><i class='icon-dashboard icon-large'></i></td><td><ul>";
            for (i = 0; i < this.values.length; i ++ ) {
                var resultIndex = this.values[i].sensi + "_" +this.values[i].overlap;
                content += "<li><i class='icon-rss icon-large " + valueColors[i % valueColors.length] + "'></i> " + Math.round(100 * stats.areaCoverage[resultIndex]) + "% / " + Math.round(100 * stats.popCoverage[resultIndex]) + "%</li>";
            }
            content += "</ul></td>" +
                    "</tr><tr>" + 
                    "<td class='center'><i class='icon-trophy icon-large'></i></td><td> " + Math.round(100 * stats.areaProgress) + "% / " + Math.round(100 * stats.popProgress) + "%</td>" +
                    "</tr>" +
                    "</table>";
            this.info.setContent(content);
            this.info.setPosition(circle.center);
            this.info.open(this.coverageMap.map);
        };
        

        var resultsPolygonInfo = function(index, stats, polygon, name, isUrban) {
            var displayName = name ? name : (isUrban ? "Urban" : "Suburban") + " polygon " + (((index - 1) / 2) + 1);
            var content = "<h3><i class='icon-circle-blank icon-large  " + (isUrban ? "urban" : "suburban") + "'></i> " + displayName + "</h3><br/>" +
            "<table class='city-area-info'>" +
            "<tr>" +
            "<td class='center'><i class='icon-group icon-large'></i></td><td>" + Math.round(stats.density) + " Pop/km&sup2;</td>" +
            "</tr><tr>" +
            "<td class='center'><i class='icon-user icon-large'></i></td><td> " + Math.round(stats.population) + " hab</td>" +
            "</tr><tr>" +
            "<td class='center'><i class='icon-dashboard icon-large'></i></td><td><ul>";
            for (i = 0; i < this.values.length; i ++ ) {
                var resultIndex = this.values[i].sensi + "_" +this.values[i].overlap;
                content += "<li><i class='icon-rss icon-large " + valueColors[i % valueColors.length] + "'></i> " + Math.round(100 * stats.areaCoverage[resultIndex]) + "% / " + Math.round(100 * stats.popCoverage[resultIndex]) + "%</li>";
            }
            content += "</ul></td></tr><tr>" + 
            "<td class='center'><i class='icon-trophy icon-large'></i></td><td> " + Math.round(100 * stats.areaProgress) + "% / " + Math.round(100 * stats.popProgress) + "%</td>" +
            "</tr></table>";
            this.info.setContent(content);
            this.info.setPosition(polygon.getPath().getAt(0));
            this.info.open(this.coverageMap.map);
        };

        var polygonBounds = function(polygon) {
            var latLng;
            var bounds;
            var path = polygon.getPath();
            for (k = 0; k < path.getLength(); k ++) {
                latLng = new google.maps.LatLng(path.getAt(k).lat(), path.getAt(k).lng());
                if (k === 0) {
                    bounds = new google.maps.LatLngBounds(latLng, latLng);
                } else {
                    bounds = bounds.extend(latLng);
                }
            }
            return bounds;
        };

        // save created polygons
        this.polygons = [];

        // save created circle
        this.circles = [];

        for (var index in this.areaStats) {
            if (index >= 0) {
                var stats = this.areaStats[index];
                if (stats.jacksonType == "circleStatsBean") {
                    // manage Circle
                    var circleData = stats.area;
                    var latLngCenter = new google.maps.LatLng(circleData.center.lat, circleData.center.lng);
                    var latLngRight = new google.maps.LatLng(latLngCenter.lat(), latLngCenter.lng() + (circleData.width/2));
                    var isUrban = circleData.urban;
                    var name = circleData.name;
                    var cOptions = {
                        center : latLngCenter,
                        radius : google.maps.geometry.spherical.computeDistanceBetween(latLngCenter, latLngRight)
                    };
                    var cColors;
                    if (isUrban) {
                        cColors = {
                                fillColor: colorPurple,
                                strokeColor: colorPurple,
                                zIndex: 10
                        };
                    } else {
                        cColors = {
                                fillColor: colorOrange,
                                strokeColor: colorOrange,
                                zIndex: 1
                        };
                    }
                    $.extend(cOptions, cColors);
                    this.circles[index] = new google.maps.Circle($.extend([], baseOptions, cOptions));
                    google.maps.event.addListener(this.circles[index], "click", $.proxy(resultsCircleInfo, this, index, stats, this.circles[index], name, isUrban));
                    if (!this.bounds) {
                        this.bounds = this.circles[index].getBounds();
                    } else {
                        this.bounds = this.bounds.union(this.circles[index].getBounds());
                    }
                } else {
                    // Manage Polygons
                    var polygonData = stats.area;
                    var paths = [];
                    for (j = 0; j < polygonData.coords.length; j++) {
                        paths[j] = new google.maps.LatLng(polygonData.coords[j].lat, polygonData.coords[j].lng);
                    }
                    var pOptions = {
                            paths : paths
                    };
                    var pColors;
                    if (polygonData.urban) {
                        pColors = {
                                fillColor: colorPurple,
                                strokeColor: colorPurple,
                                zIndex: 10
                        };
                    } else {
                        pColors = {
                                fillColor: colorOrange,
                                strokeColor: colorOrange,
                                zIndex: 1
                        };
                    }
                    $.extend(pOptions, pColors);
                    this.polygons[index] = new google.maps.Polygon($.extend([], baseOptions, pOptions));
                    google.maps.event.addListener(this.polygons[index], "click", $.proxy(resultsPolygonInfo, this, index, stats, this.polygons[index], polygonData.name, polygonData.urban));
                    if (!this.bounds) {
                        this.bounds = polygonBounds(this.polygons[index]);
                    } else {
                        this.bounds = this.bounds.union(polygonBounds(this.polygons[index]));
                    }
                }
            }
        }

        this.popupNode = $("#popup");
        this.popup = this.popupNode.dialog({
            modal: true,
            autoOpen: false,
            buttons: {
                Ok: function() {
                    $(this).dialog("close");
                }
            }
        });
        var coverageHeader = $(".coverage-header");
        this.updateValues = function() {
            // Header
            var header = $('#header-values');
            header.empty();
            header.append('<th colspan=4/>');
            coverageHeader.attr("colspan", this.values.length);
            for (var i = 0; i < this.values.length; i++) {
                var endLabel = this.values[i].overlap > 1 ? ' with redundancy ' + this.values[i].overlap : '';
                header.append('<th><span class="icon-rss icon-large ' + valueColors[i % valueColors.length] + '"></span> ' + this.values[i].sensi + 'dB' + endLabel);
            }
            $('table#global-results th').each($.proxy(function (i, elem) {
                var $th = $(elem);
                $th.css('width', Math.floor(100 / (4 + this.values.length)) + '%');
            }, this));
            // Body
            $('td.result-cell').remove();
            $('tr.result-line').each($.proxy(function(i, elem) {
                var $elem = $(elem);
                for (var j = 0; j < this.values.length; j++) {
                    // the urban, suburban and rural line are at index -1,-2 and -3
                    var line = -(i+1);
                    var stats = this.areaStats[line];
                    var index = this.values[j].sensi + "_" +this.values[j].overlap;
                    var coverageArea = Number(100 * stats.areaCoverage[index]);
                    var coveragePop = Number(100 * stats.popCoverage[index]);
                    $elem.append('<td class="result-cell">' + Math.round(coverageArea) + '% / ' + Math.round(coveragePop) + '%</td>');
                }
                var targetArea = Number(100 * stats.areaProgress);
                var targetPop = Number(100 * stats.popProgress);
                $elem.append('<td class="result-cell">' + Math.round(targetArea) + '% / ' + Math.round(targetPop) + '%</td>');
            }, this));
            // close all infos (they need to be updated)
            this.info.close();
        };

        this.$configureBtn = $("<span title='Select the values to show/hide' class='configure-columns-btn icon-cog'></span>");
        // Adds the configure button next to the table headers
        coverageHeader.prepend(this.$configureBtn);

        /**
         * Closes the container (removes the 'open' class and remove nodes after transition).
         */
        this.closeItem = function(container) {
            // Remove nodes after transition
            this.removeAfterTransition(container);

            // Remove OPEN classes
            container.removeClass('opened');
        };

        this.removeAfterTransition = function(container) {
            container.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function transitionEnd(e) {
                clearTimeout(timer);
                container.remove();
            });

            // Security timer used for...guess who... FIREFOX !!!!! ahaha IE is not guilty this time :)
            var timer = setTimeout(function() {
                container.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
                container.remove();
            }, 300);
        };

        // Config btn clicked : Retrieve current state for the user, and then open the selection side-popup
        this.$configureBtn.click($.proxy(function configureBtnClicked() {
            var $body = $('body');
            var $content = $("<div class='field-selection-box city-area-values'><div id='field-selection-box-title'>Values selection</div><div id='field-selection-form'></div></div>");
            var $overlay = $("<div class='overlay'></div>");
            var $form = $content.find('#field-selection-form');
            var close = $.proxy(function() {
                this.closeItem($content);
                this.closeItem($overlay);
                $body.removeClass('noscroll');
            }, this);
            
            // Add all existing values with an option to delete it
            var $valueList = $("<ul id='selected-values'></ul>");
            $form.append($valueList);
            
            // inner form to add/update values set to display
            var $innerForm = $('<div id="inner-form"></div>');
            $innerForm.append('<button id="new-value-btn" class="flat-button">Add</button>');
            $innerForm.append('<button id="delete-value-btn" class="flat-button">Delete</button>');
            $innerForm.append('<div id="sensi-selector" class="inner-form-field">' +
                                 '<label class="field-label">Margin</label>' +
                                 '<div id="slider-wrapper">' +
                                     '<div id="sensi" class="slider"></div>' +
                                     '<label id="sensi-value" class="slider-value-label"><span id="value"></span> dB</label>' +
                                 '</div>' +
                             '</div>');
            $innerForm.append('<div id="redundancy-selector" class="toggle-selector inner-form-field">' +
                                 '<label class="field-label">Redundancy</label>' +
                                 '<ul class="toggle state-options">' +
                                     '<li id="1" class="toggle-option">1</li><li id="2" class="toggle-option">2</li><li id="3" class="toggle-option">3+</li>' +
                                 '</ul>' +
                             '</div>');
            $content.append($innerForm);
            var $slider = $content.find("#sensi-selector div.slider");
            $slider.slider({
                range: "min",
                animate:500,
                min: 0,
                max: this.settings.maxDb - this.settings.minDb,
                change : function(event, ui) {
                    var selectedLi = $valueList.find("li.selected");
                    selectedLi.data("sensi", ui.value);
                    var content = (selectedLi.data("sensi")) + ' dB Redundancy ' + selectedLi.data("overlap");
                    selectedLi.attr("data-on", content);
                    selectedLi.attr("data-off", content);
                },
                slide: function( event, ui ) {
                    $content.find("#sensi-value span#value").text(ui.value);
                }
            });

            var $toggle = $content.find(".toggle-selector");
            $toggle.find(".toggle-option").on("click", function(event){
                var $item = $(this);
                if(!$item.hasClass("selected")){
                    var mode = event.target.id;
                    var selectedLi = $valueList.find("li.selected");
                    selectedLi.data("overlap", mode);
                    var content = (selectedLi.data("sensi")) + ' dB Redundancy ' + selectedLi.data("overlap");
                    selectedLi.attr("data-on", content);
                    selectedLi.attr("data-off", content);
                    // remove class for all options
                    $(".toggle-option").removeClass("selected");
                    $item.addClass("selected");
                }
            });

            var updateInnerForm = function(here) {
                // update slider widget
                var value = here.data("sensi");
                $slider.slider("value", value);
                $content.find("#sensi-value span#value").text(value);
                // update toggle widget
                var $item = $toggle.find(".toggle-option").eq(here.data("overlap") - 1);
                $(".toggle-option").removeClass("selected");
                $item.addClass("selected");
            };

            // fill values list
            var first = true;
            for (var i = 0; i < this.values.length; i++) {
                var value = this.values[i];
                var content = value.sensi + ' dB Redundancy ' + value.overlap;
                var $value = $('<li ' + (first ? 'class="selected" ' : '') + 'data-sensi="' + value.sensi + '" data-overlap="' + value.overlap + '" data-on="' + content + '" data-off="' + content + '"></li>');
                if (first) {
                    updateInnerForm($value);
                }
                first = false;
                $valueList.append($value);
            }

            // add a new value
            $content.find('button#new-value-btn').on('click', $.proxy(function(event) {
                var maxValueNb = this.CONSTANTS.get('MAX_DISPLAYED_VALUES');
                var $liList = $valueList.find("li");
                if ($liList.length >= maxValueNb) {
                    messages.warn('Only ' + maxValueNb + ' values set are allowed, you cannot add one more');
                } else {
                    $liList.removeClass("selected");
                    var sensi = 0;
                    var overlap = 1;
                    var content = sensi + ' dB Redundancy ' + overlap;
                    var $value = $('<li class="selected" data-sensi="' + sensi + '" data-overlap="' + overlap + '" data-on="' + content + '" data-off="' + content + '"></li>');
                    $valueList.append($value);
                    updateInnerForm($value);
                }
            }, this));

            // delete current selected value
            $content.find('button#delete-value-btn').on('click', $.proxy(function(event) {
                var minValueNb = this.CONSTANTS.get('MIN_DISPLAYED_VALUES');
                var $liList = $valueList.find("li");
                if ($liList.length <= minValueNb) {
                    messages.warn('At least ' + minValueNb + ' values set are needed, you cannot delete one');
                } else {
                    var $selected = $valueList.find("li.selected");
                    $selected.remove();
                    var $first = $liList.first();
                    $first.addClass("selected");
                    updateInnerForm($value);
                }
            }, this));

            // bind each value
            $valueList.find("li").click(function(event) {
                var here = $(event.target);
                $form.find("ul#selected-values li").removeClass("selected");
                here.addClass("selected");
                updateInnerForm(here);
            });

            $content.append("<button id='submit-field-selection-btn' class='flat-button'>Apply</button>");
            $content.find('button#submit-field-selection-btn').on('click', $.proxy(function(event) {
                var $values = $form.find("ul#selected-values li");
                var valuesNb = $values.length;
                var maxValueNb = this.CONSTANTS.get('MAX_DISPLAYED_VALUES');

                if (valuesNb > maxValueNb) {
                    messages.warn('Only ' + maxValueNb +
                            ' values set are allowed, please unselect ' + (valuesNb - maxValueNb) +
                            ' set of values');
                } else {
                    var selectedValues = [];
                    $values.each(function(i, value) {
                        $value = $(value);
                        selectedValues.push({sensi : parseInt($value.data("sensi")), overlap: parseInt($value.data("overlap"))});
                    });
                    this.values = selectedValues;
                    $.ajax({
                        type: 'POST',
                        url: this.CONSTANTS.get('USER_PREFS_EDIT_URL'),
                        contentType: 'application/json; charset=UTF-8',
                        data: JSON.stringify({"values": this.values}),
                        success: $.proxy(function(data) {
                            this.updateValues();
                        }, this)
                    });
                    close();
                }
            }, this));

            $body.append($content);
            $body.prepend($overlay);

            setTimeout(function() {
                $content.addClass('opened');
                $overlay.addClass('opened');
                $body.addClass('noscroll');
            }, 200);

            // Close popup when clicking anywhere on the overlay, or pressing ESC
            $overlay.one('click', function(e) {
                close();
            });
            $(document).one('keyup', function(e) {
                if (e.keyCode == 27) {
                    close();
                }
            });
        }, this));

        // export csv action
        $("#city-area-export").click($.proxy(function() {
            var sensis = [];
            var overlaps = [];
            for (var i = 0; i < this.values.length; i++) {
                sensis.push(this.values[i].sensi);
                overlaps.push(this.values[i].overlap);
            }
            $.ajax({
                type: 'GET',
                url: '/cityArea/csv/static/global-export.csv',
                traditional: true,
                data: {'sensis': sensis, 'overlaps': overlaps, 'taskId': this.settings.taskId},
                success: function(result) {
                    messages.info("An email will be sent to you when results are available");
                }
            });
        }, this));


        this.coverageMap.map.fitBounds(this.bounds);
        this.loadCoverage();

        $.ajax({
            type: 'GET',
            url: this.CONSTANTS.get('USER_PREFS_LIST_URL'),
            dataType: 'json',
            success: $.proxy(function(data) {
                // use default value if no user prefs
                if (data.length > 0) {
                    this.values = data;
                }
                this.updateValues();
            }, this)
        });
    };
});
